export const WATCH_DEMO_BYPASS_KEY = 'bypass-watch-demo-form';
export const RESOURCE_DOWNLOAD_BYPASS_KEY = 'bypass-resource-form';
export const COOKIE_BANNER_KEY = 'cookie-banner-closed';
export const DEMO_REQUESTED_SESSION_KEY = 'requested-demo';
